import {UserProfile} from '@shared/interfaces';
import {User} from '@firebase/auth';

export enum ActionTypes {
  GET_USER = '[Auth] GetUser',
  SET_INIT = '[Auth] SetInit',
  CHECK_SESSION = '[Auth] CheckSession',
  DELETE_USER = '[Auth] DeleteUser',
  GOOGLE_LOGIN = '[Auth] GoogleLogin',
  LINK_ACCT_TO_GOOGLE = '[Auth] LinkAcctToGoogle',
  LOGIN_SUCCESS = '[Auth] LoginSuccess',
  LOGIN_FAILURE = '[Auth] LoginFailure',
  LOGIN_REDIRECT = '[Auth] LoginRedirect',
  LOGOUT = '[Auth] Logout',
  LOGOUT_SUCCESS = '[Auth] LogoutSuccess',
  EDIT_USER = '[Auth] EditUser',
  UPDATE_USER_PREFERENCE = '[Auth] UpdateUserPreference',
  REFRESH_TOKEN = '[Auth] RefreshToken'
}

export class GetUser {
  static readonly type = ActionTypes.GET_USER;

  constructor(public payload: Partial<User>) {
  }
}

export class SetInit {
  static readonly type = ActionTypes.SET_INIT;

  constructor(public payload?: { url?: string; canNavigate?: boolean }) {
  }
}

export class CheckSession {
  static readonly type = ActionTypes.CHECK_SESSION;

  constructor(public payload?: { url?: string; canNavigate?: boolean }) {
  }
}

export class DeleteUser {
  static readonly type = ActionTypes.DELETE_USER;
}

export class GoogleLogin {
  static readonly type = ActionTypes.GOOGLE_LOGIN;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class LoginSuccess {
  static readonly type = ActionTypes.LOGIN_SUCCESS;

  constructor(public payload: User) {
  }
}

export class LoginFailure {
  static readonly type = ActionTypes.LOGIN_FAILURE;

  // Payload is error object
  constructor(public payload: any) {
  }
}

export class LoginRedirect {
  static readonly type = ActionTypes.LOGIN_REDIRECT;

  constructor(public redirectUrl: any) {
  }
}

export class Logout {
  static readonly type = ActionTypes.LOGOUT;
}

export class LogoutSuccess {
  static readonly type = ActionTypes.LOGOUT_SUCCESS;
}

export class LinkAcctToGoogle {
  static readonly type = ActionTypes.LINK_ACCT_TO_GOOGLE;

  constructor(public payload: { linkType: 'login', redirectLink: string }) {
  }
}

export class EditUser {
  static readonly type = ActionTypes.EDIT_USER;

  constructor(public payload: { userData: UserProfile }) {
  }
}

export class UpdateUserPreference {
  static readonly type = ActionTypes.UPDATE_USER_PREFERENCE;

  constructor(public payload: { key: string; value: boolean; }) {
  }
}

export class RefreshToken {
  static readonly type = ActionTypes.REFRESH_TOKEN;
}
